var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHand = function SvgHand(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.111328,
    width: 36,
    height: 24,
    rx: 12,
    fill: "#0077CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.111328,
    width: 36,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_431_168)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.332 12.7783V7.77832C15.332 7.5131 15.4374 7.25875 15.6249 7.07121C15.8125 6.88368 16.0668 6.77832 16.332 6.77832C16.5972 6.77832 16.8516 6.88368 17.0391 7.07121C17.2267 7.25875 17.332 7.5131 17.332 7.77832V12.1117",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.332 7.77767V6.44434C17.332 6.31301 17.3579 6.18298 17.4082 6.06165C17.4584 5.94033 17.5321 5.83009 17.6249 5.73723C17.7178 5.64437 17.828 5.57071 17.9493 5.52046C18.0707 5.4702 18.2007 5.44434 18.332 5.44434C18.4634 5.44434 18.5934 5.4702 18.7147 5.52046C18.836 5.57071 18.9463 5.64437 19.0391 5.73723C19.132 5.83009 19.2057 5.94033 19.2559 6.06165C19.3062 6.18298 19.332 6.31301 19.332 6.44434V12.111",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 7.77832C19.332 7.5131 19.4374 7.25875 19.6249 7.07121C19.8125 6.88368 20.0668 6.77832 20.332 6.77832C20.5972 6.77832 20.8516 6.88368 21.0391 7.07121C21.2267 7.25875 21.332 7.5131 21.332 7.77832V12.1117",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 9.11133C21.3335 8.84611 21.4388 8.59176 21.6263 8.40422C21.8139 8.21668 22.0682 8.11133 22.3335 8.11133C22.5987 8.11133 22.853 8.21668 23.0406 8.40422C23.2281 8.59176 23.3335 8.84611 23.3335 9.11133V14.778C23.3335 15.8389 22.912 16.8563 22.1619 17.6064C21.4117 18.3566 20.3943 18.778 19.3335 18.778H18.0001H18.1388C17.4763 18.7781 16.8242 18.6137 16.241 18.2995C15.6578 17.9853 15.1618 17.5312 14.7975 16.978C14.7537 16.9114 14.7102 16.8448 14.6668 16.778C14.4588 16.4587 13.7288 15.186 12.4761 12.9593C12.3484 12.7323 12.3143 12.4645 12.381 12.2128C12.4478 11.961 12.6101 11.7452 12.8335 11.6113C13.0714 11.4686 13.3502 11.4094 13.6256 11.4432C13.901 11.477 14.1571 11.6019 14.3535 11.798L15.3335 12.778",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_168",
    x1: 43,
    y1: 24.1113,
    x2: 2,
    y2: 10.1113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12757B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FDEEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 4.11133)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHand);
export default ForwardRef;